import { Seg } from "@kitchen/ui";
import { useState } from "react";
import { BomTab } from "./BomTab.js";
import { CostTab } from "./CostTab.js";
import { ForecastTab } from "./ForecastTab.js";
import { ItemsTab } from "./ItemsTab.js";
import { KardexTab } from "./KardexTab.js";
import { ReconciliationTab } from "./ReconciliationTab.js";
import { StaffMealsTab } from "./StaffMealsTab.js";
import { VouchersTab } from "./VouchersTab.js";
import { WarehousesTab } from "./WarehousesTab.js";

export type InventoryTab =
  | "warehouses"
  | "items"
  | "vouchers"
  | "kardex"
  | "bom"
  | "forecast"
  | "staff-meals"
  | "reconciliation"
  | "cost";

export function InventoryPage() {
  const [tab, setTab] = useState<InventoryTab>("warehouses");

  return (
    <div className="stack" style={{ gap: "var(--s4)" }}>
      <Seg
        label="بخش انبار و موجودی"
        value={tab}
        onChange={setTab}
        options={[
          { value: "warehouses", label: "انبارها" },
          { value: "items", label: "کالاها" },
          { value: "vouchers", label: "اسناد انبار" },
          { value: "kardex", label: "کاردکس" },
          { value: "bom", label: "فرمول خام" },
          { value: "forecast", label: "کسری فردا" },
          { value: "staff-meals", label: "مصرف پرسنل" },
          { value: "reconciliation", label: "تطابق تولید" },
          { value: "cost", label: "بهای تمام‌شده" },
        ]}
      />

      {tab === "warehouses" && <WarehousesTab />}
      {tab === "items" && <ItemsTab />}
      {tab === "vouchers" && <VouchersTab />}
      {tab === "kardex" && <KardexTab />}
      {tab === "bom" && <BomTab />}
      {tab === "forecast" && <ForecastTab />}
      {tab === "staff-meals" && <StaffMealsTab />}
      {tab === "reconciliation" && <ReconciliationTab />}
      {tab === "cost" && <CostTab />}
    </div>
  );
}
